import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule, } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatListModule } from '@angular/material/list';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { Observable, map, Subscription } from 'rxjs';

import { BreadcrumbComponent, Breadcrumb } from 'components/breadcrumb/breadcrumb.component';
import { AdvertiserService } from 'services';
import { IAdvertiser, Advertiser, User } from 'model';
import { AsTypePipe } from 'util';

@Component({
    selector: 'app-contact-directory',
    imports: [
        BreadcrumbComponent,
        CommonModule,
        MatDividerModule,
        MatIconModule,
        NgxSkeletonLoaderModule,
        MatCardModule,
        MatListModule,
        MatGridListModule,
        AsTypePipe,
    ],
    templateUrl: './contact-directory.component.html',
    styleUrl: './contact-directory.component.scss'
})
export class ContactDirectoryComponent {
    protected breadcrumbs$!: Observable<Breadcrumb[]>;
    protected advertiser$!: Observable<Advertiser>;
    protected subscriptions : Subscription[] = [];

    @Input()
    set advertiserId(advertiserId: number) {
        this.advertiser$ = this.advertiserService.getAdvertiser(advertiserId).pipe(
            map((advertiser: IAdvertiser) => new Advertiser(advertiser))
        );
        this.breadcrumbs$ = this.advertiser$.pipe(
            map((advertiser: Advertiser) => [
                { label: `${advertiser.name}`, url: `/advertiser/${advertiser.aid}/upcoming-campaigns` },
                { label: 'Contact Directory', url: '', },
            ])
        );
    }

    readonly User = User;
    readonly Advertiser = Advertiser;

    constructor(
        private advertiserService: AdvertiserService,
    ) {
    }
}
